import { smoothScrollAnchor } from "smooth-scroll-anchor";

/**
 * resetNavsStyle sets a navigation anchor
 * to its active state
 *
 * @param nav link in navbar
 */
const setActiveNavStyle = async (nav: HTMLAnchorElement) => {
  nav.classList.add("active");
};
/**
 * resetNavsStyle resets all the links in the navigation bar
 * to their inactive state
 */
const resetNavsStyle = async () => {
  const navs: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll("nav div a");
  const f = () => {
    navs.forEach(n => {
      n.classList.remove("active");
    });
  };
  f();
};

/**
 * findActive highlights the current active link in the navbar
 */
const findActive = async () => {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const intersectionThreshold = 0.2;

  const navs: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll("nav div a");

  navs.forEach(n => {
    if (n.getAttribute("href") === url.pathname) {
      setActiveNavStyle(n);
    }
    // homepage
    if (url.pathname.length === 3 && n.hash === url.hash) {
      setActiveNavStyle(n);
    }
  });

  const homePage = document.getElementById("home-page");
  if (homePage !== null) {
    const options = {
      rootMargin: "0px",
      threshold: intersectionThreshold,
    };
    const observer = new IntersectionObserver(e => {
      if (e[0].intersectionRatio <= intersectionThreshold) return;
      resetNavsStyle();
      const nav = document.getElementById(`${e[0].target.id}-nav`);
      if (nav !== null) {
        setActiveNavStyle(nav as HTMLAnchorElement);
      }
    }, options);

    navs.forEach(n => {
      if (n.hash !== "") {
        const area = document.querySelector(n.hash);
        if (area !== null) observer.observe(area);
      }
    });
  }
};

export default () => {
  findActive();
  smoothScrollAnchor({ behaviour: "smooth", block: "start", offset: 110 });
};
